import { CommonModule } from '@angular/common';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { FundamentalChartModule } from 'ChartApp/ts/features/fundamental-chart/fundamental-chart.module';
import { UniverseQuartileChartModule } from 'ChartApp/ts/features/universe-quartile-chart/universe-quartile-chart.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import * as i0 from "@angular/core";
export class FundUniverseQuartileChartModule {
}
FundUniverseQuartileChartModule.ɵfac = function FundUniverseQuartileChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundUniverseQuartileChartModule)(); };
FundUniverseQuartileChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FundUniverseQuartileChartModule });
FundUniverseQuartileChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        DisabledModule,
        FundamentalChartModule,
        IconModule,
        MetricSelectorModalModule,
        SecurityListSelectorModalModule,
        SingleSelectDropdownModule,
        TooltipModule,
        UniverseQuartileChartModule] });
